import {useContext} from 'react'

import PropTypes from 'prop-types'

import {htmlStringToReactElement} from '@s-ui/js/lib/react'
import Context from '@s-ui/react-context'

const HelpText = ({sellerName}) => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const URL_STATICS_IMAGES = config.get('URL_STATICS_IMAGES')
  const imageUrl = `${URL_STATICS_IMAGES}pictograms/Money.svg`

  return (
    <div className="mt-UserTransactionPriceConfirm-helpText">
      <img
        src={imageUrl}
        height={48}
        width={58}
        alt={i18n.t('VEHICLE_TRANSACTION.CONFIRM_PRICE.HELP_TEXT', {sellerName})}
      />
      <div className="mt-UserTransactionPriceConfirm-helpTextInfo">
        {htmlStringToReactElement(i18n.t('VEHICLE_TRANSACTION.CONFIRM_PRICE.HELP_TEXT', {sellerName}))}
      </div>
    </div>
  )
}

HelpText.displayName = 'HelpText'
HelpText.propTypes = {
  sellerName: PropTypes.string
}

export default HelpText
